<div class="blog-details-desc">
  <div class="article-image">
    <img [src]="content.featureImageUrl" alt="image" />
  </div>
  <div class="article-content">
    <div class="entry-meta">
      <ul>
        <li><i-feather name="clock"></i-feather>{{ content.contentPublishDate | date: 'dd MMM yyyy' }}</li>
        <li><i-feather name="user"></i-feather> {{ content.authorName.trim() }}</li>
      </ul>
    </div>
    <h4>{{ content.contentTitle }}</h4>
    <div [innerHTML]="content.content | safeHtml"></div>
  </div>
  <div class="article-footer">
    <div class="article-tags">
      <ng-container *ngFor="let tag of content.contentTags; index as i">
        <a href="javascript:void(0)" class="text-uppercase">{{ tag }}</a>
      </ng-container>
    </div>
  </div>
</div>
